import {a11yProps, TabPanel, useStyles} from "../../../components/custom/Tabs";
import {useIntl} from "react-intl";
import React from "react";
import {AppBar, Tab, Tabs} from "@material-ui/core";
import {ProceduresTab} from "./ProceduresTab";
import {ResponseTimesTab} from "./ResponseTimesTab";
import {OthersTab} from "./OthersTab";
import { GeneralTab } from "./GeneralTab";

export const ParameterizationTabs = () => {
  const classes = useStyles();
  const intl = useIntl();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          className={classes.tabs}
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          centered
          TabIndicatorProps={{
            style: {
              backgroundColor: "#0A8FDC",
            },
          }}
        >
          <Tab
            className={classes.tab}
            label={`${intl.formatMessage({ id: "Procedures" }).toUpperCase()}`}
            {...a11yProps(0)}
          />
          <Tab
            className={classes.tab}
            label={`${intl
              .formatMessage({ id: "ResponseTimes" })
              .toUpperCase()}`}
            {...a11yProps(1)}
          />
          {/* TAB OTROS */}
          <Tab
            className={classes.tab}
            label={`${intl
              .formatMessage({ id: "Others" })
              .toUpperCase()}`}
            {...a11yProps(2)}
          />
          <Tab
            className={classes.tab}
            label={`${intl.formatMessage({ id: "General" }).toUpperCase()}`}
            {...a11yProps(3)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <ProceduresTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ResponseTimesTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <OthersTab/>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <GeneralTab />
      </TabPanel>
    </div>
  );
}